import { Button } from "@/components/ui/button";
import { SpinnerGap } from "@phosphor-icons/react";
import { ADMIN_EMAIL, FieldLabel } from "../settings/shared";

export function AccountInfoCard({ workspace, workspaceName, onWorkspaceNameChange, onSave, saving, isAdmin }) {
  return (
    <div className="bg-[var(--bg-card)] border border-[var(--border)] rounded-lg p-6">
      <h2 className="font-['Cormorant_Garamond'] text-lg font-semibold text-[#FF4400] mb-1">Account</h2>
      <p className="text-sm text-[var(--text-muted)] mb-5">Your billing account. Businesses and team members belong here.</p>

      <div className="space-y-4">
        <div>
          <FieldLabel label="Account Name" />
          <div className="flex gap-2">
            <input className="flex-1 bg-[var(--bg-base)] border border-[var(--border-strong)] rounded-lg px-3 py-2 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:outline-none focus:ring-1 focus:ring-[#FF4400]"
              value={workspaceName} onChange={(e) => onWorkspaceNameChange(e.target.value)} placeholder="My Account"
              disabled={workspace.your_role === "member"} data-testid="workspace-name-input" />
            {workspace.your_role !== "member" && (
              <Button onClick={onSave} disabled={saving || workspaceName === workspace.name}
                className="bg-[#FF4400] hover:bg-[#FF6633] text-white" data-testid="save-workspace-name-btn">
                {saving ? <SpinnerGap size={16} className="animate-spin" /> : "Save"}
              </Button>
            )}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 pt-2">
          <div>
            <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-1">Plan</label>
            <p className="text-sm text-[var(--text-secondary)] capitalize" data-testid="workspace-tier">
              {isAdmin ? "Master Admin" : (workspace.plan_tier || workspace.tier || "free_beta").replace("_", " ")}
            </p>
          </div>
          <div>
            <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-1">Seats</label>
            <p className="text-sm text-[var(--text-secondary)]" data-testid="workspace-seats">
              {isAdmin ? "Unlimited" : `${workspace.seat_used || workspace.members?.length || 1} / ${workspace.seat_limit || 26}`}
            </p>
          </div>
          <div>
            <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-1">Your Role</label>
            <p className="text-sm text-[var(--text-secondary)] capitalize" data-testid="workspace-role">
              {isAdmin ? "Master Admin" : workspace.your_role}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
